/**
 * LXRY — Produkt-Karussell
 * Scroll-Snap-Carousel mit zentrierter aktiver Karte.
 *
 * - Pro data-lxry-carousel Wrapper eine eigene Instanz.
 * - Alle DOM-Queries innerhalb des Wrappers → mehrere Karussells
 *   auf einer Seite laufen kollisionsfrei.
 * - Keine externen Libraries. requestAnimationFrame-throttled scroll.
 * - Keyboard: ArrowLeft / ArrowRight navigieren wenn der Track focused
 *   ist.
 * - Shopify designMode: Re-Init auf shopify:section:load Events.
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  function initCarousel(root) {
    if (!root || root.__lxryCarouselInit) return;

    var track = root.querySelector('[data-lxry-carousel-track]');
    if (!track) return;

    var cards = Array.prototype.slice.call(
      track.querySelectorAll('[data-lxry-carousel-card]')
    );
    if (cards.length === 0) return;

    root.__lxryCarouselInit = true;

    var prevBtn = root.querySelector('[data-lxry-carousel-prev]');
    var nextBtn = root.querySelector('[data-lxry-carousel-next]');
    var dotsWrap = root.querySelector('[data-lxry-carousel-dots]');

    var dots = [];
    var activeIdx = -1;
    var ticking = false;

    // === Dots erzeugen ===
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      cards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lxry-carousel__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Gehe zu Produkt ' + (i + 1));
        dot.setAttribute('aria-selected', 'false');
        dot.addEventListener('click', function () {
          scrollToIndex(i);
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    // === Aktive Karte: die mit Center am nächsten zur Track-Mitte ===
    function getActiveIndex() {
      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      var closestIdx = 0;
      var closestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var cardCenter = c.offsetLeft + c.offsetWidth / 2;
        var dist = Math.abs(cardCenter - trackCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closestIdx = i;
        }
      }
      return closestIdx;
    }

    // === scrollToIndex: i-te Karte mittig snappen ===
    function scrollToIndex(i, opts) {
      var clamped = Math.max(0, Math.min(cards.length - 1, i));
      var card = cards[clamped];
      if (!card) return;
      var target = card.offsetLeft + card.offsetWidth / 2 - track.clientWidth / 2;
      var instant = opts && opts.instant;
      if (instant || prefersReducedMotion) {
        track.scrollLeft = target;
      } else {
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
    }

    // === update: aktive Klasse, Dots, Button-Disabled ===
    function update() {
      ticking = false;
      var idx = getActiveIndex();

      if (idx !== activeIdx) {
        for (var i = 0; i < cards.length; i++) {
          cards[i].classList.toggle('is-active', i === idx);
        }
        for (var j = 0; j < dots.length; j++) {
          dots[j].classList.toggle('is-active', j === idx);
          dots[j].setAttribute(
            'aria-selected',
            j === idx ? 'true' : 'false'
          );
        }
        activeIdx = idx;
      }

      if (prevBtn) prevBtn.disabled = activeIdx <= 0;
      if (nextBtn) nextBtn.disabled = activeIdx >= cards.length - 1;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(getActiveIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(getActiveIndex() + 1);
      });
    }

    // Keyboard-Navigation: ← → wenn Track fokussiert ist
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        scrollToIndex(getActiveIndex() - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        scrollToIndex(getActiveIndex() + 1);
      } else if (e.key === 'Home') {
        e.preventDefault();
        scrollToIndex(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        scrollToIndex(cards.length - 1);
      }
    });

    // === Initial: mittlere Karte aktiv, instant-positionieren ===
    // Wir warten einen Frame, damit Layout (flex + padding) berechnet ist.
    window.requestAnimationFrame(function () {
      var initialIdx = Math.floor((cards.length - 1) / 2);
      scrollToIndex(initialIdx, { instant: true });
      update();
    });

    // Cleanup-Handle für Shopify designMode Re-Render
    root.__lxryCarouselCleanup = function () {
      track.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (dotsWrap) dotsWrap.innerHTML = '';
      root.__lxryCarouselInit = false;
    };
  }

  function initAll(scopeEl) {
    var scope = scopeEl || document;
    var roots = scope.querySelectorAll('[data-lxry-carousel]');
    for (var i = 0; i < roots.length; i++) {
      initCarousel(roots[i]);
    }
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Shopify Theme Editor: Re-Init wenn Section nachgeladen wird
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      // e.target ist der neu geladene Section-Container
      initAll(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var roots = e.target.querySelectorAll('[data-lxry-carousel]');
      for (var i = 0; i < roots.length; i++) {
        var r = roots[i];
        if (r.__lxryCarouselCleanup) r.__lxryCarouselCleanup();
      }
    });
  }
})();
